import __request__ from "routing/request";
export function create(JSONbody, requestOptions) {
  return __request__("POST", "/system/translation_feedback", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkDelete(JSONbody, requestOptions) {
  return __request__("POST", "/system/translation_feedback/bulk_delete", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function bulkUpdateStatus(JSONbody, requestOptions) {
  return __request__("POST", "/system/translation_feedback/bulk_status", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function exportCsv(query, filters, requestOptions) {
  return __request__("GET", "/system/translation_feedback/export/csv", null, { "query": query, "filters": filters }, {
    "Accept": ["text/csv"]
  }, requestOptions);
}
export function exportJson(query, filters, requestOptions) {
  return __request__("GET", "/system/translation_feedback/export/json", null, { "query": query, "filters": filters }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getPage(page = 1, per_page = 50, query, filters, sort = "created_at", order = "desc", requestOptions) {
  return __request__("GET", "/system/translation_feedback/paginated", null, { "page": page, "per_page": per_page, "query": query, "filters": filters, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function applyResolutions(JSONbody, requestOptions) {
  return __request__("POST", "/system/translation_feedback/resolutions", JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(id, requestOptions) {
  return __request__("DELETE", `/system/translation_feedback/${id}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function updateStatus(id, JSONbody, requestOptions) {
  return __request__("PUT", `/system/translation_feedback/${id}/status`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
